import { twx } from '@/utils/twx';

export const CommonButton = twx.button`rounded-lg font-semibold inline-flex items-center justify-center`;
export interface CommonButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'primary' | 'secondary' | 'gray' | 'error';
}
